import styled from '@emotion/styled'
import {COLORS} from '../constants'

/**
 * Below Material-UI's `sm` breakpoint (600px) the control drops its long labels and stretches to
 * the full width of the page, so the two segments stay comfortably tappable on a phone (PT-5719).
 */
const BELOW_SM = '@media (max-width: 599px)'

/** Segmented control shell holding one {@link Segment} per available view. */
export const Segmented = styled.div`
  display: inline-flex;
  align-self: flex-start;
  gap: 4px;
  padding: 4px;
  border: 1px solid ${COLORS.border};
  border-radius: 10px;
  background-color: ${COLORS.mutedBg};

  ${BELOW_SM} {
    display: flex;
    align-self: stretch;
    width: 100%;
  }
`

/**
 * One perspective of the segmented control. The active segment is filled with the brand colour and
 * lifted with a shadow, so which view is live reads at a glance rather than from the label alone.
 */
export const Segment = styled.button<{isActive: boolean}>`
  cursor: pointer;
  flex: 1;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  border: none;
  border-radius: 8px;
  transition: background-color 120ms ease, color 120ms ease, box-shadow 120ms ease;
  color: ${({isActive}) => (isActive ? COLORS.cardBg : COLORS.mutedText)};
  background-color: ${({isActive}) => (isActive ? COLORS.brand : 'transparent')};
  box-shadow: ${({isActive}) => (isActive ? '0 1px 3px rgba(0, 0, 0, 0.18)' : 'none')};

  &:hover {
    color: ${({isActive}) => (isActive ? COLORS.cardBg : COLORS.foreground)};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.brand};
    outline-offset: 2px;
  }
`

/** The full label ("Master MM View"), hidden on narrow viewports in favour of {@link ShortLabel}. */
export const FullLabel = styled.span`
  ${BELOW_SM} {
    display: none;
  }
`

/** The shortened label ("Master"), shown only below the `sm` breakpoint. */
export const ShortLabel = styled.span`
  display: none;

  ${BELOW_SM} {
    display: inline;
  }
`
